<template>
  <div>
    <h1>Login</h1>

    <div class="block">
      Email*
      <input ref="email" v-model="email" @click="select($refs.email, email)" type="text" @keyup.enter="select($refs.password, password)" />
      Password*
      <input ref="password" v-model="password" @click="select($refs.password, password)" type="password" @keyup.enter="login" />
      <button @click="recover">I forgot my password...</button>
      <button @click="login">Login</button>
      <button @click="$router.push({ path: '/' })">Home</button>
      <button @click="register">I want to register</button>

      <p class="p-error" v-if="showMissingError">Missing fields from above</p>
      <p class="p-error" v-if="showEmailBadFormat">Email format required, example: john@domain.com</p>
      <p class="p-error" v-if="showLoginError">Incorrect Login, try again</p>
    </div>

    <div id="twitter-login">
      <button @click="loginWithTwitter">Login with Twitter</button>
    </div>
  </div>
</template>

<script>
import * as validator from "email-validator";
import firebase from "@/firebase";
import router from "@/router";

export default {
  data() {
    return {
      showEmailBadFormat: false,
      showMissingError: false,
      showLoginError: false,
      email: "",
      password: "",
    };
  },

  created() {
    window.scrollTo(0, 0);
  },

  methods: {
    select(ref, model) {
      ref.focus();
      ref.setSelectionRange(0, model.length);
    },

    loginWithTwitter() {
      const provider = new firebase.firebase.auth.TwitterAuthProvider();
      this.loginWithProvider(provider);
    },

    loginWithProvider(provider) {
      firebase.auth
        .signInWithPopup(provider)
        .then(() => {
          this.loginSuccess("twitter");
        })
        .catch((error) => {
          this.loginError(error);
        });
    },

    async login() {
      this.showEmailBadFormat = false;
      this.showMissingError = false;
      this.showLoginError = false;

      if (!validator.validate(this.email)) {
        this.showEmailBadFormat = true;
        this.select(this.$refs.email, this.email);
        this.name = "";
        this.email = "";
        this.password = "";
      }

      if (this.email == null || this.email == "") {
        this.showMissingError = true;
        this.select(this.$refs.email, this.email);
        this.name = "";
        this.email = "";
        this.password = "";
      }

      if (this.password == null || this.password == "") {
        this.showMissingError = true;
        this.select(this.$refs.password, this.password);
        this.name = "";
        this.email = "";
        this.password = "";
      }

      if (this.showEmailBadFormat || this.showMissingError) {
        return;
      }

      firebase.auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          this.loginSuccess("emailAndPassowrd");
        })
        .catch((error) => {
          this.loginError(error);
        });
    },

    loginSuccess(method) {
      firebase.analytics.logEvent("login", { method });
      router.push({ path: "/dashboard" });
    },

    loginError(error) {
      this.showLoginError = true;
      this.select(this.$refs.email, this.email);
      this.password = "";
      console.error(error);
    },

    recover() {
      router.push({ path: "password-reset" });
    },

    register() {
      router.push({ path: "register" });
    },
  },
};
</script>

<style scoped>
.p-error {
  color: red;
}
.block {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  grid-gap: 10px;
  padding: 10px;
  margin-left: 200px;
  margin-right: 200px;
  margin-top: 50px;
}
</style>
